<template lang='pug'>
  .fp-simple-tree
    .fp-simple-tree-root-actions
      .fp-simple-tree-root-action(v-for='action in options.actions')
        fpui-button(color='blue', left, unbordered, @click='call(action)', reverse, :icon='action.icon') {{action.label}}
    h1(v-if='options.name') {{options.name}}
    table.fp-simple-tree-content
      tbody
        tr.fp-tree-item.placeholder(v-if='!rows.length', @click='call(options.placeholder)')
          td {{ options.placeholder.label}}
        fp-simple-tree-item(
          :key='item.id||index',
          v-for='item, index in rows',
          :options='options',
          :is-last='index === rows.length - 1'
          :item='item'
          :tree-id="treeId"
          :root='rootElement'
          @toggle='toggle(item)'
          @render='renderTreeView'
        )

</template>

<script>
import './FpSimpleTree.less'
import FpTreeFlat from '../tree-view/FpTreeFlat'
import FpTreeBorderCompute from '../tree-view/FpTreeBorderCompute'
import FpSimpleTreeItem from './FpSimpleTreeItem'

export default {
  components: {
    FpSimpleTreeItem
  },
  props: {
    options: {
      type: Object,
      required: true
    }
  },
  data () {
    let that = this
    return {
      search: '',
      rows: [],
      rootElement: {
        children: [],
        type: 'root',
        parent: null
      },
      treeId: (new Date().getTime() + Math.floor((Math.random() * 10000) + 1)).toString(16),
      globalActions: {
        add (newItem) {
          that.rootElement.children.push(newItem)
          that.renderTreeView()
        },
        update (item) {
          const findQuery = (items) => {
            for (let idx in items) {
              let tmp = items[idx]
              if (item.id === tmp.id) return tmp
              if (tmp.children) {
                let find = findQuery(tmp.children)
                if (find) return find
              }
            }
            return null
          }
          let query = findQuery(that.rootElement.children)
          if (query) {
            Object.keys(item).forEach(key => that.$set(query, key, item[key]))
          }
        }
      }
    }
  },
  mounted () {
    Promise.resolve(this.options.items)
      .then(items => {
        items.forEach(item => this.rootElement.children.push(item))
        this.renderTreeView()
      })
  },
  methods: {
    toggle (item) {
      this.$set(item, 'open', !item.open)
      this.renderTreeView()
    },
    call (action) {
      action.click.call(this.globalActions, this.rootElement)
    },
    searchChange (event) {
      this.search = event.target.value
      this.renderTreeView()
    },
    renderTreeView () {
      FpTreeFlat(this.rootElement, this.search, this.options.type)
        .then((rows) => {
          rows = FpTreeBorderCompute(rows)
          this.rows.splice(0, this.rows.length)
          rows.forEach(row => this.rows.push(row))
        })
    }
  }
}
</script>
